<template>
  <div class="cloud-intercom-page">
    <div class="ci-body ci-body--center">
      <div class="ci-status-icon">
        <img src="@/assets/img/intercom/warning-location-setting@3x.webp" />
      </div>
      <h2 class="ci-body__heading">
        {{ $t('Intercom.CloudIntercom.MediaDeniedPage.Heading') }}
      </h2>
      <p class="ci-body__message">
        {{ $t('Intercom.CloudIntercom.MediaDeniedPage.Message1') }}<br>
        {{ $t('Intercom.CloudIntercom.MediaDeniedPage.Message2') }}
      </p>
      <div class="ci-info-block">
        <div class="ci-info-block__title-wrap">
          <img src="@/assets/img/intercom/info@3x.webp" />
          <span class="ci-info-block__title-text">{{ $t('Intercom.CloudIntercom.MediaDeniedPage.HowToTitle') }}</span>
        </div>
        <ol class="ci-info-block__list">
          <i18n path="Intercom.CloudIntercom.LocationDeniedPage.Step1" tag="li">
            <template #safari>
              <img class="ios" src="@/assets/img/intercom/ios-safari@3x.webp" />
            </template>
            <template #chrome>
              <img src="@/assets/img/intercom/google-chrome@3x.webp" />
            </template>
          </i18n>
          <li>{{ $t('Intercom.CloudIntercom.MediaDeniedPage.Step2') }}</li>
          <li>{{ $t('Intercom.CloudIntercom.MediaDeniedPage.Step3') }}</li>
          <li>{{ $t('Intercom.CloudIntercom.MediaDeniedPage.Step4') }}</li>
        </ol>
        <div class="ci-info-block__separator"></div>
        <div class="ci-info-block__additional-title">
          {{ $t('Intercom.CloudIntercom.Common.IPhoneAdditionalTitle') }}
        </div>
        <div class="ci-info-block__additional">
          {{ $t('Intercom.CloudIntercom.MediaDeniedPage.AdditionalDesc') }}
        </div>
      </div>
    </div>
    <div class="ci-footer">
      <button
        class="ci-btn ci-btn--primary"
        @click="$emit('request-media')"
      >
        {{ $t('Intercom.CloudIntercom.MediaDeniedPage.Reload') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaDeniedPage'
}
</script>

<style lang="scss" scoped>
@import './cloudIntercom';

.ci-body {
  padding-top: 56px;
}

.ci-footer {
  margin-top: 8px;
}
</style>
